import React from 'react';

import { HashRouter } from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import ScrollToTop from './helpers/ScrollToTop';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <HashRouter>
        <ScrollToTop />
        <App />
    </HashRouter>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// nothing
reportWebVitals();
